<template>
  <div class="card p-4">
    <div class="col-12 d-md-flex justify-content-lg-between mb-3 clickable" @click.prevent="toggle">
      <h4><span class="badge badge-danger"><b>{{ showing ? "--":"+"}}</b></span> Parcelamento</h4>
    </div>

    <div class="collapse show" id="collapse-quota">
      <div class="col-12 mb-3">
        <table class="table table-hover table-sm">
          <thead>
            <tr>
              <th>Parcela</th>
              <th>Percentual desconto</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="quota,i in quotas" :key="i">
              <th>{{ quota.quota }}x</th>
              <td>
                <div class="input-group input-group-sm">
                  <input type="number" v-model="quota.percent" />
                  <span class="input-group-append">
                    <span class="input-group-text">%</span>
                  </span>
                </div>
              </td>
              <td>
                <button class="btn btn-success btn-sm" @click="saveQuota(quota)">
                  <i class="fa fa-save"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  props: {
    course: {
      required: true
    }
  },
  watch: {
    course: {
      immediate: true,
      handler ( val, old ) {
        if ( val != undefined && val != old ) {
          this.load()
        }
      }
    }
  },
  data () {
    return {
      showing: true,
      quotas: [],
    }
  },
  methods: {
    saveQuota: function (quota) {
      Axios.post('/teacher/course/quota', quota)
        .then( () => {
          this.load()
        })
        .catch( err => {
          console.error(err)
        })
    },
    load: function () {
      Axios.get(`/teacher/course/quota?course=${ this.course }`)
        .then( res => {
          this.quotas = res.data
        })
        .catch( err => {
          console.error( err )
        })
    },
    toggle: function () {
      this.showing = !this.showing
      $("#collapse-quota").collapse('toggle')
    }
  }
}
</script>

<style>

</style>
